{
  "ru": {
    "title": "Гражданство",
    "emptyResults": "Ничего не найдено",
    "tryAgain": "Попробуйте изменить поисковый запрос и проверить, нет ли опечаток",
    "search": "Поиск"
  },
  "kk": {
    "title": "Азаматтық",
    "emptyResults": "Ешнәрсе табылған жоқ",
    "tryAgain": "Іздеуді өзгертіп көріңіз және қателерді тексеріңіз",
    "search": "Іздеу"
  },
  "en": {
    "title": "Citizenship",
    "emptyResults": "Nothing found",
    "tryAgain": "Try changing the search query and checking for typos",
    "search": "Search"
  }
}
